<div class="topline">
  <h2>Rewards/Snacks</h2>
  <div class="actions">
    <button mat-stroked-button color="primary" (click)="exportRewards()">Export rewards</button>
    <button mat-stroked-button color="primary" (click)="importRewards()">Import rewards</button>
    <button mat-raised-button color="primary" (click)="addReward()">Add Reward</button>
  </div>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="catalog-type">
    <mat-label>Type</mat-label>
    <mat-select [(ngModel)]="catalogType" (selectionChange)="onCatalogTypeChange()" [disabled]="loading">
      <mat-option *ngFor="let option of catalogTypeOptions" [value]="option.value">
        {{option.label}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="nameSearch" (ngModelChange)="queueFilter()" placeholder="Reward name">
    <button *ngIf="nameSearch" matSuffix mat-icon-button type="button" aria-label="Clear name search" (click)="nameSearch = ''; queueFilter()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search">
    <mat-label>Title</mat-label>
    <input matInput [(ngModel)]="titleSearch" (ngModelChange)="queueFilter()" placeholder="Banner title">
    <button *ngIf="titleSearch" matSuffix mat-icon-button type="button" aria-label="Clear title search" (click)="titleSearch = ''; queueFilter()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search">
    <mat-label>Campaign</mat-label>
    <input matInput [(ngModel)]="campaignSearch" (ngModelChange)="queueFilter()" placeholder="Campaign name">
    <button *ngIf="campaignSearch" matSuffix mat-icon-button type="button" aria-label="Clear campaign search" (click)="campaignSearch = ''; queueFilter()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search search-wide">
    <mat-label>Full Text / Metadata</mat-label>
    <input matInput [(ngModel)]="fullTextSearch" (ngModelChange)="queueFilter()" placeholder="Optional broader search">
    <button *ngIf="fullTextSearch" matSuffix mat-icon-button type="button" aria-label="Clear full text search" (click)="fullTextSearch = ''; queueFilter()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint>Use this only when you need the broader payload search.</mat-hint>
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let reward">{{reward.name}}</td>
    </ng-container>

    <ng-container matColumnDef="campaigns">
      <th mat-header-cell *matHeaderCellDef>Campaigns</th>
      <td mat-cell *matCellDef="let reward">
        <span *ngFor="let campaign of (campaigns[reward.id] || []); let isLast = last" [style.textDecoration]="campaign.state === 'Closed' ? 'line-through' : 'none'">
          <span class="campaign-label">
            <span>{{campaign.name}}</span>
            <mat-icon
              *ngIf="campaign.allBrands"
              class="all-brands-warning"
              [matTooltip]="allBrandsCampaignTooltip"
              aria-label="Campaign applies to all brands"
            >warning</mat-icon>
          </span>{{isLast ? '' : ', '}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let reward">{{reward.bannerDetails?.title || reward.name}}</td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef>Location</th>
      <td mat-cell *matCellDef="let reward">
        <span *ngIf="reward.location">lat={{reward.location.y?.toFixed(6)}}<br>long={{reward.location.x?.toFixed(6)}}<br>radius={{reward.radius}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="textColor">
      <th mat-header-cell *matHeaderCellDef>Text Color</th>
      <td mat-cell *matCellDef="let reward">{{reward.textColor}}</td>
    </ng-container>

    <ng-container matColumnDef="backgroundColor">
      <th mat-header-cell *matHeaderCellDef>Background Color</th>
      <td mat-cell *matCellDef="let reward">{{reward.backgroundColor}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let reward">
        <button mat-icon-button [matMenuTriggerFor]="rewardActionsMenu" [matMenuTriggerData]="{reward: reward}" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name','campaigns','title','location','textColor','backgroundColor','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name','campaigns','title','location','textColor','backgroundColor','actions']" (click)="editReward(row)"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading...</div>
  <div class="empty" *ngIf="!loading && items.length === 0">There are no rewards or snacks to show.</div>
</div>

<mat-menu #rewardActionsMenu="matMenu">
  <ng-template matMenuContent let-reward="reward">
    <button mat-menu-item (click)="$event.stopPropagation(); editReward(reward)">Modify Reward</button>
    <button mat-menu-item (click)="$event.stopPropagation(); showClaimed($event, reward)">Show Claimed</button>
    <button mat-menu-item (click)="$event.stopPropagation(); clone($event, reward)">Clone</button>
  </ng-template>
</mat-menu>
